"use client";
import { jsx as S } from "react/jsx-runtime";
import { isSSR as a } from "../../common/helpers/isSSR.js";
import { css as d } from "@emotion/react";
import u from "@emotion/styled";
import { FONT_SIZES as l } from "../../tokens/font-sizes/FontSizes.js";
import { forwardRef as y, useState as T, useEffect as g } from "react";
const r = y(
  ({ dateTime: t, feDateStyle: m, feSize: i = "md", feTimeStyle: e, locale: o, ...s }, n) => {
    const [c, f] = T("-");
    return g(() => {
      if (a())
        return;
      const p = new Date(t).toLocaleString(o, {
        dateStyle: m,
        timeStyle: e
      });
      f(p.toString());
    }, [t, m, e, o]), /* @__PURE__ */ S(j, { ...s, "data-comp": "time", dateTime: t, feSize: i, ref: n, children: c });
  }
);
r.displayName = "Time";
const $ = r, j = u.time(
  ({ feSize: t }) => d`
		font-size: ${t === "sm" && l.sm};
	`
);
export {
  $ as default
};
